import type {
    FC
} from "react";
import type {
    PreferenceFormProps
} from "../type";
import Tabs from "../../../components/tabs";

type PreferenceSegmentProps = Omit<PreferenceFormProps, "form" | "trigger">;

const PreferenceSegment: FC<PreferenceSegmentProps> = ({
    spreadBehaviour,
    customLocalize,
    customTheme,
    isShowTitle,
    isDisabled,
    activeKey,
    onSelect,
    options,
    testID,
    style,
    title,
    size
}) => {
    return <Tabs
        spreadBehaviour={spreadBehaviour === "stretch" ? "stretch" : "baseline"}
        customLocalize={customLocalize}
        customTheme={customTheme}
        onValueChange={onSelect}
        isDisabled={isDisabled}
        listRole="radiogroup"
        value={activeKey}
        variant="segment"
        testID={testID}
        style={style}
        size={size}
    >
        <Tabs.List
            customTheme={customTheme}
            title={title}
        >
            {
                options.map((option) => {
                    const languageProps = option.lang ? {
                        accessibilityLanguage: option.lang,
                        lang: option.lang
                    } : {};

                    return <Tabs.Trigger
                        {...languageProps}
                        accessibilityLabel={isShowTitle ? undefined : option.title}
                        title={isShowTitle ? option.title : undefined}
                        customLocalize={customLocalize}
                        customTheme={customTheme}
                        value={option.key}
                        icon={option.icon}
                        key={option.key}
                    />;
                })
            }
        </Tabs.List>
    </Tabs>;
};
export default PreferenceSegment;
